import NotificationPage from './NotificationPage';

export default NotificationPage;
